import React from "react";
// eslint-disable-next-line no-unused-vars
import IBanner from '../types/IBanner';
import useStore from '../store/useStore';


const BannerComponent = ({ title }: IBanner) => {

  const {

    setParams,
    setFilter,
    isLoggedIn,

    //view /*filters, view, settings*/
  } = useStore((state: any) => ({

    setParams: state.setParams,
    setFilter: state.setFilter,
    isLoggedIn:state.settings.params.isLoggedIn

  }));

  const navigateDailySessions = () => {
    console.log("Navigate to daily sessions ");

    setParams('type', 'sessions');
    setParams('activeRoute', 'sessions');
    setFilter('MySessions', 1);



    //navigate("/sessions/daily");
  };

  return (
    <div>
      <div className="ituBanner">
        <div className="ituContainer"  style={{display: 'flex', justifyContent: 'space-between'}}>
          <h1>{title}</h1>
          {
          title==='Events' ? (
          isLoggedIn==='true' ? (

          <a className="ituBtn" onClick={navigateDailySessions}  style={{color: '#fff', borderColor: '#fff', padding:"1rem", cursor:'pointer', fontSize: '1.2rem'}}>My sessions</a>
          )
          :(<></>)

        

          ):(<></>)
          }
        </div>
      </div>
    </div>);
}

export default BannerComponent;